var _g, _g2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 200,
    height: 100,
    rx: 5,
    stroke: "#2563eb",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 40 L150 10 L270 40",
    stroke: "#2563eb",
    strokeWidth: 4,
    fill: "none",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 55,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 90,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 55,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 90,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 55,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 90,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 55,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 90,
    width: 30,
    height: 25,
    fill: "#2563eb",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 120,
    width: 50,
    height: 20,
    fill: "#2563eb",
    opacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 15,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 65 Q5 40 25 40 Q45 40 45 65",
    stroke: "#2563eb",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 20,
    height: 25,
    stroke: "#2563eb",
    strokeWidth: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 43,
    x2: 50,
    y2: 43,
    stroke: "#2563eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 50,
    x2: 50,
    y2: 50,
    stroke: "#2563eb",
    strokeWidth: 2
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 185,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: "bold",
    fill: "#282c34",
    textAnchor: "middle"
  }, "\n    trud\n    ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#2563eb"
  }, "os"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9821f43ca13e1de327773bd746047441.svg";
export { ForwardRef as ReactComponent };